import React from 'react';
import HeroSection from './HeroSection';
import SituacoesSection from './SituacoesSection';
import ObjetivoSection from './ObjetivoSection';

import CenariosSection from './CenariosSection';

import ParaQuemSection from './ParaQuemSection';
import CtaFinalSection from './CtaFinalSection';
import FaqSection from './FaqSection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-neutral-950">
      <main>
        <HeroSection />
        <SituacoesSection />
        <ObjetivoSection />
        <ParaQuemSection />

        <CenariosSection />


        <CtaFinalSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
